import React, { Suspense, useRef } from "react";

import { SharedProps } from "~/components/shared/FormYAMLEditorField/types";

export * from "~/components/shared/FormYAMLEditorField/types";

const YamlEditor = React.lazy(() => import("./YamlEditor"));

import Spinner from "~/components/shared/Spinner";
import { ErrorBoundary } from "~/lib/Bugsnag";

const CODEMIRROR_BUFFER = 8;
const CODEMIRROR_LINE_HEIGHT = 20;

const ApproximateHeightLoader = ({ value }: { value: string | undefined }) => {
  const lines = value ? value.split("\n").length : 0;
  const height = CODEMIRROR_BUFFER + lines * CODEMIRROR_LINE_HEIGHT;

  return (
    <div className="flex w-full items-center justify-center" style={{ height: height }}>
      <span>
        <Spinner />
      </span>
    </div>
  );
};

const FormYAMLEditorFieldLoader = ({
  codeMirrorInstanceRef,
  required,
  inputRequired,
  name,
  id,
  value,
  autofocus,
  readOnly,
  lineWrapping,
  placeholder,
  data,
  ...props
}: SharedProps) => {
  const fallbackRef = useRef();

  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <span className="red">There was an error loading the editor. Please reload the page.</span>
      )}
    >
      <Suspense fallback={<ApproximateHeightLoader value={value} />}>
        <YamlEditor
          name={name}
          id={id}
          value={value}
          autofocus={autofocus}
          readOnly={readOnly}
          lineWrapping={lineWrapping}
          required={required || inputRequired}
          placeholder={placeholder}
          data={data}
          codeMirrorInstanceRef={codeMirrorInstanceRef || fallbackRef}
          {...props}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

export default FormYAMLEditorFieldLoader;
